import React from "react";
import { connect } from "react-redux";

import {
  getCurrentGroups,
  getFeatureGroupFromWizardGroup,
} from "./lookWizardFunctions";
import LookWizardContext from "./lookWizardContext";


const LookWizardContextProvider = (props) => {

  const {wizardActiveItem, wizardActiveStep, wizardSelectedValues} = props;

  const currentGroups = getCurrentGroups(wizardActiveItem, wizardActiveStep, wizardSelectedValues);
  const wizardGroup = currentGroups[0];

  let featureGroup = null;
  let selectedWizardCustomGroup = null;
  if (currentGroups.length === 1 && currentGroups[0].nodeType === "group") {
    featureGroup = getFeatureGroupFromWizardGroup(wizardGroup);
  } else if (currentGroups.length && currentGroups[0].nodeType === "custom"
    && wizardSelectedValues[wizardActiveStep]?.wizardGroup) {
    selectedWizardCustomGroup = wizardSelectedValues[wizardActiveStep].wizardGroup;
  }

  const selectedFeature = wizardSelectedValues[wizardActiveStep]?.selectedFeature;
  const isSingleFeature = wizardSelectedValues[wizardActiveStep]?.singleFeature;
  const featureGroupFeature = featureGroup && featureGroup.activeFeature && !currentGroups[0].title
    ? featureGroup.activeFeature
    : null;

  const selectedWizardFeature = selectedFeature;

  const isCompletedStep = wizardActiveStep > -1 && !currentGroups.length;

  const lookWizardContextValues = {
    currentGroups,
    featureGroup,
    wizardGroup,
    isCompletedStep,
    selectedWizardFeature,
    featureGroupFeature,
    isSingleFeature,
    selectedWizardCustomGroup,
  }

  return (
    <LookWizardContext.Provider value={lookWizardContextValues}>
      {props.children}
    </LookWizardContext.Provider>
  )
};

const mapStateToProps = (store) => {
  const {wizardActiveItem, wizardActiveStep, wizardSelectedValues} = store.wizardState;

  return {
    wizardActiveItem,
    wizardActiveStep,
    wizardSelectedValues,
  };
};

export default connect(mapStateToProps)(LookWizardContextProvider)
